import React, { useEffect, useRef, useState } from "react";
import Client from "./Client";
import ace from "ace-builds/src-noconflict/ace";
import "./ai.css";
import "ace-builds/src-noconflict/ext-language_tools";
import {
  faSave,
  faCopy,
  faRobot,
  faTimes,
  faUndo,
  faRedo,
  faPlay,
  faExpand,
  faCompress,
  faUsers,
  faSignOutAlt,
  faCode,
  faArrowsAlt,
  faCompressAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Import all language modes
// Import all language modes - COMPLETE VERSION
import "ace-builds/src-noconflict/mode-prolog";
import "ace-builds/src-noconflict/mode-c_cpp";
import "ace-builds/src-noconflict/mode-php";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-groovy";
import "ace-builds/src-noconflict/mode-csharp";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-sql";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/mode-ruby";
import "ace-builds/src-noconflict/mode-rust";
import "ace-builds/src-noconflict/mode-typescript";
import "ace-builds/src-noconflict/mode-scala";
import "ace-builds/src-noconflict/mode-dart";
import "ace-builds/src-noconflict/mode-r";
import "ace-builds/src-noconflict/mode-julia";
import "ace-builds/src-noconflict/mode-golang";
import "ace-builds/src-noconflict/mode-html";      // NEW
import "ace-builds/src-noconflict/mode-css";       // NEW
import "ace-builds/src-noconflict/mode-sh";        // NEW
import "ace-builds/src-noconflict/mode-kotlin";    // NEW
import "ace-builds/src-noconflict/mode-swift";     // NEW


// Import themes
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/theme-dracula";
import "ace-builds/src-noconflict/theme-solarized_dark";
import "ace-builds/src-noconflict/theme-solarized_light";
import "ace-builds/src-noconflict/theme-terminal";
import "ace-builds/src-noconflict/theme-tomorrow_night";
import "ace-builds/src-noconflict/theme-tomorrow_night_bright";

import $ from "jquery";
import { initSocket } from "../socket.js";
import { ACTIONS } from "../Actions";
import "./style.css";

import {
  useNavigate,
  useLocation,
  Navigate,
  useParams,
} from "react-router-dom";
import { toast } from "react-hot-toast";
import { debounce } from "lodash";

import Chat from "./chat.js";
import { connectTypingSocket } from "./TypingSocket";

// Language templates
const LANGUAGE_TEMPLATES = {
   html: `<!DOCTYPE html>
<html>
<head>
    <title>My Page</title>
    <style>
        body { font-family: Arial; }
    </style>
</head>
<body>
    <h1>Hello World</h1>
    <p>Edit this HTML</p>
</body>
</html>`,

  css: `/* CSS Code */
body {
    background-color: #f0f0f0;
    font-family: Arial, sans-serif;
}

.container {
    width: 80%;
    margin: 0 auto;
    padding: 20px;
}`,



  htmlcss: `<!DOCTYPE html>
<html>
<head>
    <style>
        /* Your CSS here */
        body { background: #f5f5f5; }
    </style>
</head>
<body>
    <h1>HTML + CSS</h1>
</body>
</html>`,


  node: `// Node.js JavaScript
const fs = require('fs');

console.log("Hello from Node.js!");

// Example function
function greet(name) {
    return "Hello, " + name;
}`,


 bash: `#!/bin/bash
echo "Hello from Bash!"

# List files
ls -la

# Variables
name="World"
echo "Hello, \$name"`
,

  c: `#include <stdio.h>

int main() {
    printf("Hello, World!\\n");
    return 0;
}`,
  cpp: `#include <iostream>
using namespace std;

int main() {
    cout << "Hello, World!" << endl;
    return 0;
}`,
  python: `def main():
    print("Hello, World!")

if __name__ == "__main__":
    main()`,
  java: `public class Main {
    public static void main(String[] args) {
        System.out.println("Hello, World!");
    }
}`,
  javascript: `console.log("Hello, World!");

// Function example
function greet(name) {
    return "Hello, " + name + "!";
}`,
  php: `<?php
echo "Hello, World!\\n";

function greet($name) {
    return "Hello, " . $name . "!";
}
?>`,
  csharp: `using System;

class Program {
    static void Main() {
        Console.WriteLine("Hello, World!");
    }
}`,
  ruby: `puts "Hello, World!"

def greet(name)
    "Hello, #{name}!"
end`,
  rust: `fn main() {
    println!("Hello, World!");
}`,
  typescript: `console.log("Hello, World!");

interface Person {
    name: string;
}

function greet(person: Person): string {
    return "Hello, " + person.name + "!";
}`,
  go: `package main

import "fmt"

func main() {
    fmt.Println("Hello, World!")
}`,
  swift: `import Swift

print("Hello, World!")`,
  kotlin: `fun main() {
    println("Hello, World!")
}`,
  mysql: `-- Create a simple table
CREATE TABLE users (
    id INT PRIMARY KEY,
    name VARCHAR(50)
);

-- Insert sample data
INSERT INTO users (id, name) VALUES (1, 'John Doe');

-- Select data
SELECT * FROM users;`,
  prolog: `% Simple Prolog program
parent(john, jim).
parent(john, ann).

% Query: parent(john, X).`,
  r: `# R script
print("Hello, World!")

# Create a vector
x <- c(1, 2, 3, 4, 5)
print(x)`,

  groovy: `println "Hello, World!"

def greet(name) {
    return "Hello, !"
}`,
  scala: `object Main extends App {
    println("Hello, World!")
}`,
  julia: `println("Hello, World!")

function greet(name)
    return "Hello, " * name * "!"
end`,
  dart: `void main() {
    print('Hello, World!');
}`,
};

// Theme options
const THEMES = [
  { value: "monokai", name: "Monokai", bg: "#272822", preview: "#ff6188" },
  { value: "github", name: "GitHub", bg: "#ffffff", preview: "#24292e" },
  { value: "dracula", name: "Dracula", bg: "#282a36", preview: "#bd93f9" },
  {
    value: "solarized_dark",
    name: "Solarized Dark",
    bg: "#002b36",
    preview: "#b58900",
  },
  {
    value: "solarized_light",
    name: "Solarized Light",
    bg: "#fdf6e3",
    preview: "#dc322f",
  },
  { value: "terminal", name: "Terminal", bg: "#000000", preview: "#00ff00" },
  {
    value: "tomorrow_night",
    name: "Tomorrow Night",
    bg: "#1d1f21",
    preview: "#c5c8c6",
  },
  {
    value: "tomorrow_night_bright",
    name: "Tomorrow Night Bright",
    bg: "#000000",
    preview: "#eaeaea",
  },
];

function EditorPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { roomId } = useParams();
  const username = location.state?.username || "";

  const socketRef = useRef(null);
  const typingTimer = useRef(null);

  const [clients, setClients] = useState([]);
  const [output, setOutput] = useState("");
  const [autoRun, setAutoRun] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("html");
  const codeRef = useRef("");
  const editorRef = useRef(null);
  const [theme, setTheme] = useState("monokai");
  const [userInput, setUserInput] = useState("");
  const [language, setLanguage] = useState("html");

  const [chatOpen, setChatOpen] = useState(false);
  const [aiOpen, setAIOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const [typers, setTypers] = useState([]);
  const typingSocketRef = useRef(null);

  const [hostName, setHostName] = useState("");
  const [isSocketConnected, setIsSocketConnected] = useState(false);

  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);
  const [fontSize, setFontSize] = useState(14);
  const [loadingMessage, setLoadingMessage] = useState("");

  // Audio states and refs
  const [speakingUsers, setSpeakingUsers] = useState({});
  const [calling, setCalling] = useState(false);
  const [availableAudioUsers, setAvailableAudioUsers] = useState({});
  const [listeningTo, setListeningTo] = useState(null);
  const [isBroadcasting, setIsBroadcasting] = useState(false);
  
  // New state for editor fullscreen
  const [isEditorFullscreen, setIsEditorFullscreen] = useState(false);
  const editorContainerRef = useRef(null);

  // Audio refs
  const audioPeersRef = useRef({});
  const remoteAudioRef = useRef({});
  const audioStreamRef = useRef(null);

  // Helper: create / attach audio element for incoming stream
  const playAudio = (stream, id) => {
    let audio = remoteAudioRef.current[id];
    if (!audio) {
      audio = document.createElement("audio");
      audio.autoplay = true;
      audio.style.display = "none";
      audio.volume = 1.0;
      remoteAudioRef.current[id] = audio;
      document.body.appendChild(audio);
    }
    audio.srcObject = stream;
    audio.play().catch((e) => console.warn("Audio play failed:", e));
  };

  // WebRTC peer creation - FIXED VERSION
  const createPeer = (userId, initiator = false, isListeningMode = false) => {
    // Don't create duplicate peer
    if (audioPeersRef.current[userId]) {
      console.log("Peer already exists for:", userId);
      return audioPeersRef.current[userId];
    }

    const peer = new RTCPeerConnection({
      iceServers: [
        { urls: "stun:stun.l.google.com:19302" },
        { urls: "stun:stun1.l.google.com:19302" },
        { urls: "stun:stun2.l.google.com:19302" },
        { urls: "stun:stun3.l.google.com:19302" },
        { urls: "stun:stun4.l.google.com:19302" },
      ],
    });

    // ONLY add local tracks if:
    // 1. We have a local stream (we're broadcasting)
    // 2. We're NOT in listening mode to this specific user
    // 3. We're NOT currently listening to anyone (or we're the broadcaster)
    if (audioStreamRef.current && !isListeningMode) {
      console.log("Adding local tracks for peer:", userId);
      audioStreamRef.current.getTracks().forEach((track) => {
        try {
          peer.addTrack(track, audioStreamRef.current);
        } catch (e) {
          console.error("Error adding track:", e);
        }
      });
    }

    peer.ontrack = (e) => {
      console.log("Received track from:", userId);
      if (e.streams && e.streams[0]) {
        playAudio(e.streams[0], userId);

        // Update UI to show we're connected
        if (listeningTo === userId) {
          toast.success(
            `Connected to ${availableAudioUsers[userId]?.username || "user"}`,
          );
        }
      }
    };
    peer.onicecandidate = (e) => {
      if (e.candidate) {
        socketRef.current.emit("ice-candidate", {
          target: userId,
          candidate: e.candidate,
          from: socketRef.current.id,
          roomId,
        });
      }
    };

    peer.onconnectionstatechange = () => {
      const state = peer.connectionState;
      console.log(`Peer ${userId} connection state:`, state);

      if (state === "connected") {
        console.log("✅ Connected to:", userId);
      } else if (
        state === "disconnected" ||
        state === "failed" ||
        state === "closed"
      ) {
        console.log(`❌ Disconnected from: ${userId}`);

        // Clean up resources
        cleanupPeerConnection(userId);
      }
    };

    peer.oniceconnectionstatechange = () => {
      console.log(`Peer ${userId} ICE state:`, peer.iceConnectionState);
    };

    audioPeersRef.current[userId] = peer;

    return peer;
  };

  // Clean up peer connection
  const cleanupPeerConnection = (userId) => {
    // Remove audio element
    if (remoteAudioRef.current[userId]) {
      try {
        remoteAudioRef.current[userId].pause();
        remoteAudioRef.current[userId].srcObject = null;
        remoteAudioRef.current[userId].remove();
      } catch (e) {}
      delete remoteAudioRef.current[userId];
    }

    // Close peer connection
    if (audioPeersRef.current[userId]) {
      try {
        audioPeersRef.current[userId].close();
      } catch (e) {}
      delete audioPeersRef.current[userId];
    }

    // Update UI state
    if (listeningTo === userId) {
      setListeningTo(null);
      toast("Disconnected from user");
    }

    // Remove from available users if needed
    setAvailableAudioUsers((prev) => {
      const newState = { ...prev };
      delete newState[userId];
      return newState;
    });
  };

  // ---------- Start audio for *this* user (publish audio availability) ----------
  const startAudioCall = async () => {
    try {
      // Request microphone permission
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
      });
      audioStreamRef.current = stream;
      setCalling(true);

      // Attach local analyser for speaking detection
      try {
        const audioContext = new (
          window.AudioContext || window.webkitAudioContext
        )();
        const analyser = audioContext.createAnalyser();
        analyser.fftSize = 256;
        const source = audioContext.createMediaStreamSource(stream);
        source.connect(analyser);
        const dataArray = new Uint8Array(analyser.frequencyBinCount);

        let speaking = false;
        let lastEmit = 0;
        let running = true;

        const detectSpeech = () => {
          if (!running) return;
          analyser.getByteFrequencyData(dataArray);
          const volume =
            dataArray.reduce((a, b) => a + b, 0) / dataArray.length;
          const isSpeaking = volume > 10; // Lower threshold

          if (isSpeaking !== speaking && Date.now() - lastEmit > 200) {
            speaking = isSpeaking;
            lastEmit = Date.now();
            socketRef.current.emit("speaking", {
              roomId,
              username,
              speaking,
              socketId: socketRef.current.id,
            });
            // Update local speaking state
            setSpeakingUsers((prev) => ({
              ...prev,
              [username]: speaking,
            }));
          }

          requestAnimationFrame(detectSpeech);
        };

        detectSpeech();
        // On stop:
        running = false;
      } catch (e) {
        console.warn("Speech detection failed", e);
      }

      // Notify room that we're broadcasting
      socketRef.current.emit("audio-available", {
        roomId,
        username,
        socketId: socketRef.current.id,
        timestamp: Date.now(),
      });

      toast.success("🎤 You're now broadcasting audio");
      return true;
    } catch (err) {
      console.error("Microphone access error:", err);

      if (
        err.name === "NotAllowedError" ||
        err.name === "PermissionDeniedError"
      ) {
        toast.error(
          "Microphone permission denied. Please allow microphone access.",
        );
      } else if (
        err.name === "NotFoundError" ||
        err.name === "DevicesNotFoundError"
      ) {
        toast.error("No microphone found. Please connect a microphone.");
      } else {
        toast.error("Unable to access microphone: " + err.message);
      }

      setCalling(false);
      return false;
    }
  };

  // ---------- Stop audio for this user ----------
  const stopAudioCall = () => {
    console.log("Stopping audio call...");

    // Stop speech detection
    setSpeakingUsers((prev) => {
      const newState = { ...prev };
      delete newState[username];
      return newState;
    });
    // Close all peer connections
    Object.keys(audioPeersRef.current).forEach(cleanupPeerConnection);

    // Stop local audio stream
    if (audioStreamRef.current) {
      audioStreamRef.current.getTracks().forEach((track) => {
        try {
          track.stop();
        } catch (e) {}
      });
      audioStreamRef.current = null;
    }

    // Notify room that we stopped broadcasting
    if (socketRef.current) {
      socketRef.current.emit("audio-stopped", {
        roomId,
        socketId: socketRef.current.id,
        username,
      });
    }
    // Reset all states
    setCalling(false);
    setListeningTo(null);
    setAvailableAudioUsers({});

    toast.success("Audio stopped");
  };

  // ---------- When another user offers their audio availability ----------
  const handleAudioAvailable = ({
    socketId,
    username: otherName,
    timestamp,
  }) => {
    if (!socketId || socketId === socketRef.current.id) return;

    console.log("Audio available from:", otherName, socketId);

    setAvailableAudioUsers((prev) => ({
      ...prev,
      [socketId]: {
        username: otherName,
        since: timestamp || Date.now(),
        socketId,
      },
    }));
    toast.success(`${otherName} is broadcasting audio`, {
      duration: 5000,
    });
  };

  // ---------- When another user stops broadcasting ----------
  const handleAudioStopped = ({ socketId }) => {
    console.log("Audio stopped from:", socketId);

    cleanupPeerConnection(socketId);

    setAvailableAudioUsers((prev) => {
      const newState = { ...prev };
      delete newState[socketId];
      return newState;
    });

    if (socketId === listeningTo) {
      toast("Broadcaster stopped audio");
    }
  };

  // ---------- User clicks Listen on a remote broadcaster ----------
  const startListeningTo = async (targetSocketId) => {
    if (!targetSocketId || targetSocketId === socketRef.current.id) {
      toast.error("Cannot listen to yourself");
      return;
    }

    // Check if target is available
    const targetUser = availableAudioUsers[targetSocketId];
    if (!targetUser) {
      toast.error("User is not broadcasting");
      return;
    }

    // If already listening to someone, stop first
    if (listeningTo && listeningTo !== targetSocketId) {
      cleanupPeerConnection(listeningTo);
    }

    try {
      setListeningTo(targetSocketId);

      // Create peer as initiator (we request the stream)
      const peer = createPeer(targetSocketId, true, true);

      // Create and send offer
      const offer = await peer.createOffer({
        offerToReceiveAudio: true,
        offerToReceiveVideo: false,
      });

      await peer.setLocalDescription(offer);

      socketRef.current.emit("offer", {
        target: targetSocketId,
        sdp: peer.localDescription,
        from: socketRef.current.id,
        roomId,
        isAudioOnly: true,
      });

      console.log("Sent offer to:", targetSocketId);
      toast.success(`Connecting to ${targetUser.username}...`);
    } catch (error) {
      console.error("Error starting to listen:", error);
      cleanupPeerConnection(targetSocketId);
      toast.error("Failed to connect to broadcaster");
    }
  };

  // ---------- Start/Stop Broadcasting Functions ----------
  const startBroadcasting = async () => {
    const success = await startAudioCall();
    if (success) {
      setIsBroadcasting(true);
    }
  };

  const stopBroadcasting = () => {
    stopAudioCall();
    setIsBroadcasting(false);
  };

  // Toggle editor fullscreen function
  const toggleEditorFullscreen = () => {
    if (!isEditorFullscreen) {
      // Enter fullscreen
      if (editorContainerRef.current.requestFullscreen) {
        editorContainerRef.current.requestFullscreen();
      } else if (editorContainerRef.current.webkitRequestFullscreen) {
        editorContainerRef.current.webkitRequestFullscreen();
      } else if (editorContainerRef.current.msRequestFullscreen) {
        editorContainerRef.current.msRequestFullscreen();
      }
    } else {
      // Exit fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    setIsEditorFullscreen(!isEditorFullscreen);
  };

  // Listen for fullscreen change events
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsEditorFullscreen(
        document.fullscreenElement || 
        document.webkitFullscreenElement || 
        document.msFullscreenElement
      );
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

  // ---------- Socket event handlers for signaling ----------
  useEffect(() => {
    if (!socketRef?.current) return;

    const socket = socketRef.current;

    // Existing users when joining audio room
    socket.on("all-audio-users", (users) => {
      console.log("All audio users:", users);
      if (!Array.isArray(users)) return;

      users.forEach((user) => {
        if (user.socketId && user.socketId !== socket.id) {
          handleAudioAvailable({
            socketId: user.socketId,
            username: user.username || "Unknown",
            timestamp: user.timestamp,
          });
        }
      });
    });

    // Someone just made audio available
    socket.on("audio-available", handleAudioAvailable);

    // Someone stopped broadcasting
    socket.on("audio-stopped", handleAudioStopped);

    // A remote user left the audio room
    socket.on("user-left-audio", ({ socketId }) => {
      console.log("User left audio:", socketId);
      handleAudioStopped({ socketId });
    });
    // Request to listen to us (we're the broadcaster)
    socket.on("request-listen", async ({ requesterId, requesterUsername }) => {
      console.log(
        "Received listen request from:",
        requesterId,
        requesterUsername,
      );

      if (!isBroadcasting || !audioStreamRef.current) {
        console.log("Not broadcasting, ignoring request");
        socket.emit("listen-request-denied", {
          target: requesterId,
          reason: "not_broadcasting",
        });
        return;
      }

      try {
        // Create peer for this listener
        const peer = createPeer(requesterId, false, false);

        // Create and send offer
        const offer = await peer.createOffer();
        await peer.setLocalDescription(offer);

        socket.emit("offer", {
          target: requesterId,
          sdp: peer.localDescription,
          from: socket.id,
          roomId,
          isAudioOnly: true,
        });

        console.log("Sent offer to listener:", requesterId);
      } catch (error) {
        console.error("Error handling listen request:", error);
        cleanupPeerConnection(requesterId);
      }
    });
    // Incoming offer (someone wants to send us audio)
    socket.on("offer", async ({ from, sdp, isAudioOnly }) => {
      try {
        console.log("Received offer from:", from);

        if (!from || !sdp) return;

        // Create peer as answerer
        const peer = createPeer(from, false, false);

        await peer.setRemoteDescription(new RTCSessionDescription(sdp));

        // Create and send answer
        const answer = await peer.createAnswer();
        await peer.setLocalDescription(answer);

        socket.emit("answer", {
          target: from,
          sdp: peer.localDescription,
          from: socket.id,
          roomId,
        });

        console.log("Sent answer to:", from);
      } catch (err) {
        console.error("Error handling offer:", err);
        cleanupPeerConnection(from);
      }
    });
    // Incoming answer (finalize connection)
    socket.on("answer", async ({ from, sdp }) => {
      try {
        console.log("Received answer from:", from);

        const peer = audioPeersRef.current[from];
        if (!peer) {
          console.warn("No peer found for answer from:", from);
          return;
        }

        await peer.setRemoteDescription(new RTCSessionDescription(sdp));
        console.log("✅ Connection established with:", from);
      } catch (err) {
        console.error("Error applying answer:", err);
        cleanupPeerConnection(from);
      }
    });
    // ICE candidates
    socket.on("ice-candidate", async ({ from, candidate }) => {
      try {
        if (!candidate) return;

        const peer = audioPeersRef.current[from];
        if (peer) {
          await peer.addIceCandidate(new RTCIceCandidate(candidate));
        } else {
          console.warn("Received ICE candidate for unknown peer:", from);
        }
      } catch (err) {
        console.error("Error adding ICE candidate:", err);
      }
    });

    // Speaking indicator
    socket.on("speaking", ({ username: who, speaking, socketId }) => {
      setSpeakingUsers((prev) => ({
        ...prev,
        [who]: speaking,
      }));
    });
    // Listen request was denied
    socket.on("listen-request-denied", ({ reason }) => {
      setListeningTo(null);
      if (reason === "not_broadcasting") {
        toast.error("User is not broadcasting anymore");
      } else {
        toast.error("Connection request was denied");
      }
    });
    // Cleanup on unmount
    return () => {
      const events = [
        "all-audio-users",
        "audio-available",
        "audio-stopped",
        "user-left-audio",
        "request-listen",
        "offer",
        "answer",
        "ice-candidate",
        "speaking",
        "listen-request-denied",
      ];
      events.forEach((event) => socket.off(event));

      // Cleanup all audio resources
      stopAudioCall();
    };
  }, [socketRef.current, isBroadcasting]);

  // Initialize with template
  const [code, setCode] = useState(() => {
    const saved = localStorage.getItem("v-editor-code");
    return saved || LANGUAGE_TEMPLATES.html  || "";
  });

  // AI Suggestion function
  const getAISuggestion = async (code, cursor, language) => {
    try {
      const res = await fetch(process.env.REACT_APP_AI_SUGGEST_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          code,
          language,
        }),
      });

      if (!res.ok) {
        throw new Error("Backend AI error");
      }

      const data = await res.json();
      return data.suggestion || "";
    } catch (err) {
      console.error("Frontend AI Error:", err);
      return "";
    }
  };

  // Apply language template
  const applyLanguageTemplate = (lang) => {
    const template =
      LANGUAGE_TEMPLATES[lang] ||
      `// ${lang} code template\nconsole.log("Hello, World!");`;

    if (editorRef.current) {
      editorRef.current.setValue(template, -1);
      codeRef.current = template;

      // Sync with other users
      if (socketRef.current?.connected) {
        socketRef.current.emit(ACTIONS.CODE_CHANGE, { roomId, code: template });
      }

      // Save to localStorage
      localStorage.setItem("v-editor-code", template);
      setCode(template);
    }
  };

  // Debounced editor change handler
 const debounceHandleChangeSync = useRef(
  debounce(() => {
    if (!editorRef.current || !socketRef.current?.connected) return;

    const code = editorRef.current.getValue();
    codeRef.current = code;

    socketRef.current.emit(ACTIONS.CODE_CHANGE, { roomId, code });

if (typingSocketRef.current?.connected) {
  typingSocketRef.current.emit("typing", { username, roomId });
}
    if (typingTimer.current) clearTimeout(typingTimer.current);

    typingTimer.current = setTimeout(() => {
      typingSocketRef.current.emit("stopTyping", { username, roomId });
    }, 1500);
  }, 300)
).current;

  // Save code to localStorage
  useEffect(() => {
    localStorage.setItem("v-editor-code", code);
  }, [code]);

  // Main socket & typing socket initialization
  useEffect(() => {
    const init = async () => {
      // Connect to typing server
      typingSocketRef.current = connectTypingSocket();
      typingSocketRef.current.emit("join-room", { roomId, username });

      typingSocketRef.current.on("updateTypers", (allTypers) => {
        const uniqueTypers = [...new Set(allTypers)].filter(
          (typer) => typer && typer !== username,
        );
        setTypers(uniqueTypers);
      });

      typingSocketRef.current.on("typing", ({ username: typingUser }) => {
        if (typingUser && typingUser !== username) {
          setTypers((prev) => {
            if (prev.includes(typingUser)) {
              return prev;
            }
            const newTypers = [...prev, typingUser];
            return [...new Set(newTypers)];
          });
        }
      });

      typingSocketRef.current.on("stopTyping", ({ username: stoppedUser }) => {
        if (stoppedUser && stoppedUser !== username) {
          setTypers((prev) => {
            const newTypers = prev.filter((u) => u !== stoppedUser);
            return [...new Set(newTypers)];
          });
        }
      });

      // Connect to main socket
      socketRef.current = await initSocket();

      socketRef.current.on("connect", () => {
        setIsSocketConnected(true);
      });

      socketRef.current.on("disconnect", () => {
        setIsSocketConnected(false);
      });

      socketRef.current.emit(ACTIONS.JOIN, { roomId, username });

      socketRef.current.on("host-info", ({ hostSocketId }) => {
        setHostName(
          hostSocketId === socketRef.current.id ? "You" : hostSocketId,
        );
      });

      socketRef.current.on(
        ACTIONS.JOINED,
        ({ clients, username: joinedUser, socketId, host }) => {
          if (joinedUser !== username) {
            toast.success(`${joinedUser} joined the room.`);
          }

          setHostName(host);

          const uniqueClients = clients.filter(
            (client, index, self) =>
              index === self.findIndex((c) => c.username === client.username),
          );

          setClients(uniqueClients);
        },
      );

      socketRef.current.on(
        ACTIONS.DISCONNECTED,
        ({ socketId, username: leftUser, clients: updatedClients }) => {
          toast(`${leftUser} left the room 👋`);

          // Add null/undefined check
          if (updatedClients && Array.isArray(updatedClients)) {
            setClients(
              updatedClients.filter(
                (client, index, self) =>
                  index ===
                  self.findIndex((c) => c.username === client.username),
              ),
            );
          } else {
            // Fallback: remove the user locally
            setClients((prevClients) =>
              prevClients.filter((c) => c.username !== leftUser),
            );
          }
        },
      );

      socketRef.current.on(
        ACTIONS.CODE_CHANGE,
        ({ code: newCode, socketId }) => {
          if (socketId !== socketRef.current.id) {
            codeRef.current = newCode;
            if (editorRef.current) {
              const currentCode = editorRef.current.getValue();
              if (currentCode !== newCode) {
                editorRef.current.setValue(newCode, -1);
              }
            }
          }
        },
      );
    };

    init();

    return () => {
  cleanupTyping();

  if (typingSocketRef.current) {
    typingSocketRef.current.emit("stopTyping", { username, roomId });
    typingSocketRef.current.disconnect();
  }

  if (socketRef.current) {
    socketRef.current.disconnect();
  }
};
  }, [roomId, navigate, username]);

  const cleanupTyping = () => {
    if (typingSocketRef.current && username && roomId) {
      typingSocketRef.current.emit("forceStopTyping", { username, roomId });
    }
  };

  // ACE Editor Setup
  useEffect(() => {
    const editor = ace.edit("editor");
    editor.setTheme(`ace/theme/${theme}`);
    editor.session.setMode(`ace/mode/${getAceMode(language)}`);

    editor.setOptions({
      fontSize: `${fontSize}px`,
      fontFamily: "'Fira Code', 'Consolas', 'Monaco', 'Courier New', monospace",
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
      enableSnippets: true,
      showLineNumbers: true,
      showGutter: true,
      showPrintMargin: false,
      wrap: true,
      indentedSoftWrap: false,
      highlightActiveLine: true,
      highlightSelectedWord: true,
      readOnly: false,
      cursorStyle: "smooth",
      mergeUndoDeltas: true,
      behavioursEnabled: true,
      wrapBehavioursEnabled: true,
      autoScrollEditorIntoView: true,
      copyWithEmptySelection: true,
    });

    // AI Completer (Fixed version - using 'caption' instead of 'name')
    const aiCompleter = {
      getCompletions: async (editor, session, pos, prefix, callback) => {
        try {
          const currentCode = editor.getValue();
          const suggestion = await getAISuggestion(currentCode, pos, language);
          if (suggestion) {
            const lines = suggestion.split("\n").filter((line) => line.trim());
            callback(
              null,
              lines.map((line) => ({
                value: line,
                meta: "AI",
                score: 1000,
                caption:
                  line.substring(0, 50) + (line.length > 50 ? "..." : ""),
              })),
            );
          } else {
            callback(null, []);
          }
        } catch (err) {
          console.error(err);
          callback(null, []);
        }
      },
    };

    // Add the completer
    editor.completers = [aiCompleter];

    editor.renderer.setPadding(20);
    editor.renderer.setScrollMargin(10, 10);
    editor.session.setUseWorker(false);
    editor.session.setTabSize(2);
    editor.session.setUseSoftTabs(true);

    // Set initial code
    editor.setValue(code || "", -1);

    // Undo/Redo commands
    editor.commands.addCommand({
      name: "myUndo",
      bindKey: { win: "Ctrl-Z", mac: "Cmd-Z" },
      exec: function () {
        editor.undo();
      },
    });

    editor.commands.addCommand({
      name: "myRedo",
      bindKey: { win: "Ctrl-Shift-Z", mac: "Cmd-Shift-Z" },
      exec: function () {
        editor.redo();
      },
    });

    // AI Suggestion trigger with Ctrl+Space
    editor.commands.addCommand({
      name: "triggerAI",
      bindKey: { win: "Ctrl-Space", mac: "Cmd-Space" },
      exec: async function () {
        const cursor = editor.getCursorPosition();
        const currentCode = editor.getValue();
        const suggestion = await getAISuggestion(currentCode, cursor, language);
        if (suggestion) {
          editor.insert(suggestion);
        }
      },
    });

    // Accept suggestion with Tab
    editor.commands.addCommand({
      name: "acceptSuggestion",
      bindKey: "Tab",
      exec: function () {
        // This would be enhanced to accept AI suggestions
        editor.insert("    "); // Default tab behavior
      },
    });

    // Update undo/redo state
    const updateUndoRedoState = () => {
      const undoManager = editor.getSession().getUndoManager();
      setCanUndo(undoManager.hasUndo());
      setCanRedo(undoManager.hasRedo());
    };

    editor.on("change", () => {
      updateUndoRedoState();
      const newCode = editor.getValue();
      setCode(newCode);
      debounceHandleChangeSync();
    });

    editorRef.current = editor;
    updateUndoRedoState();

    return () => {
      if (editorRef.current) {
        editorRef.current.destroy();
        editorRef.current = null;
      }
    };
  }, []);

  // Update theme
  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.setTheme(`ace/theme/${theme}`);
      document.body.style.backgroundColor =
        THEMES.find((t) => t.value === theme)?.bg || "#272822";
    }
  }, [theme]);

  // Update language mode
  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.session.setMode(`ace/mode/${getAceMode(language)}`);
    }
  }, [language]);

  // Update font size
  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.setOptions({
        fontSize: `${fontSize}px`,
      });
    }
  }, [fontSize]);

 const getAceMode = (lang) => {
  const modeMap = {
    html: 'html',
    css: 'css',
    htmlcss: 'html',
    javascript: 'javascript',
    python: 'python',
    node: 'javascript',
    php: 'php',
    ruby: 'ruby',
    c: 'c_cpp',
    cpp: 'c_cpp',
    java: 'java',
    csharp: 'csharp',
    go: 'golang',
    rust: 'rust',
    kotlin: 'kotlin',
    scala: 'scala',
    groovy: 'groovy',
    typescript: 'typescript',
    swift: 'swift',
    dart: 'dart',
    julia: 'julia',
    bash: 'sh',
    shell: 'sh',
    sh: 'sh',
    prolog: 'prolog',
    r: 'r',
    mysql: 'sql'
  };
  return modeMap[lang] || "text";
};

  // Code execution
  // Update your executeCode function
 const executeCode = () => {
  const currentCode = editorRef.current?.getValue();
  if (!currentCode?.trim()) {
    toast.error("Code cannot be empty.");
    return;
  }

  const isWebLanguage = ["html", "css", "htmlcss", "javascript"].includes(
    language.toLowerCase()
  );

  $.ajax({
      url: `${process.env.REACT_APP_API_URL}/compiler.php`,
    method: "POST",
    dataType: "text",
    data: {
      language: language,
      code: currentCode,
      input: userInput,
    },
    success: function (response) {
      if (isWebLanguage) {
        const newWindow = window.open();
        if (newWindow) {
          newWindow.document.write(response);
          newWindow.document.close();

          toast.success(`${language.toUpperCase()} output opened in new tab!`);

          setOutput(
            `${language.toUpperCase()} output opened in new tab.\n\nPreview:\n` +
              response.substring(0, 500) +
              (response.length > 500 ? "..." : "")
          );
        } else {
          setOutput(
            `Popup blocked! Displaying ${language.toUpperCase()} output below:\n\n`
          );

          setTimeout(() => {
            const outputDiv = document.querySelector(".output-content");
            if (outputDiv) {
              outputDiv.innerHTML = ""; // prevent duplicate iframes
              const iframe = document.createElement("iframe");
              iframe.style.width = "100%";
              iframe.style.height = "400px";
              iframe.style.border = "1px solid #ccc";
              iframe.srcdoc = response;
              outputDiv.appendChild(iframe);
            }
          }, 100);
        }
      } else {
        setOutput(response);
        toast.success("Code executed successfully!");
      }
    },
    error: function (xhr, status, error) {
      console.error("Execution error:", error);
      setOutput(xhr.responseText || "Failed to execute code");
      toast.error("Execution failed");
    },
  });
};

  // Auto-run effect

  // Also update the auto-run effect
 // Auto-run effect - COMPLETELY SILENT, NO UI INDICATION
useEffect(() => {
  if (autoRun && editorRef.current) {
    const interval = setInterval(() => {
      // Auto-run silently - no loading state, no UI changes
      const currentCode = editorRef.current.getValue();
      
      // Only run if there's code
      if (currentCode?.trim()) {
        $.ajax({
      url: `${process.env.REACT_APP_API_URL}/compiler.php`,
          method: "POST",
          dataType: "text",
          data: {
            language: language,
            code: currentCode,
            input: userInput,
          },
          success: function (response) {
            // Silently update output - no toasts, no loading indicators
            setOutput(response);
          },
          error: function (xhr) {
            // Silently update output with error - no toasts
            setOutput(xhr.responseText || "Auto-run failed");
          },
        });
      }
    }, 10000); // Changed to 30000 milliseconds (30 seconds)
    
    return () => clearInterval(interval);
  }
}, [autoRun, language, userInput]);

  const copyRoomId = async () => {
    try {
      await navigator.clipboard.writeText(roomId);
      toast.success("Room ID copied to clipboard!");
    } catch {
      toast.error("Failed to copy room ID");
    }
  };

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(editorRef.current?.getValue() || "");
      toast.success("Code copied to clipboard!");
    } catch {
      toast.error("Failed to copy code");
    }
  };

  const saveCode = () => {
    const currentCode = editorRef.current?.getValue() || "";
    const blob = new Blob([currentCode], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `code_${language}_${Date.now()}.txt`;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("Code saved!");
  };

  const leaveRoom = () => {
  cleanupTyping();

  if (socketRef.current) {
    socketRef.current.emit(ACTIONS.LEAVE, { roomId, username });
    socketRef.current.disconnect();
  }

  // Save to localStorage as fallback
  localStorage.setItem("veditor_last_room", JSON.stringify({ username, roomId }));

  navigate("/thank-you", {
    replace: true,
    state: { username, roomId }, // primary way
  });
};


  if (!location.state) return <Navigate to="/" />;

  return (
    <div
      className={`editor-container ${theme} ${isEditorFullscreen ? 'editor-fullscreen-mode' : ''}`}
      style={{ backgroundColor: THEMES.find((t) => t.value === theme)?.bg }}
      ref={editorContainerRef}
    >
      {/* Sidebar - hide when editor is in fullscreen mode */}
      {!isEditorFullscreen && (
        <div className={`sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}>
          <div className="sidebar-header">
            <div className="logo">
              <FontAwesomeIcon icon={faCode} size="lg" />
              <span>V Editor</span>
            </div>
            <button
              className="collapse-btn"
              onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
            >
              {isSidebarCollapsed ? "→" : "←"}
            </button>
          </div>

          {!isSidebarCollapsed && (
            <>
              <div className="room-info">
                <h6>
                  <FontAwesomeIcon icon={faUsers} /> Room: {roomId}
                </h6>
                <div className="user-info">
                  <span className="username">
                    <strong>{username}</strong>
                    {hostName === username && (
                      <span className="host-badge">Host</span>
                    )}
                  </span>
                  <span className="online-count">{clients.length} online</span>
                </div>
              </div>

              <div className="members-section">
                <h6>Active Members</h6>

                {/* Audio Controls Section */}
                <div className="audio-controls">
                  <div className="audio-controls-header">
                    <h6>Voice Chat</h6>
                    {isBroadcasting && (
                      <span className="audio-status broadcasting">
                        ● Broadcasting
                      </span>
                    )}
                    {listeningTo && (
                      <span className="audio-status listening">● Listening</span>
                    )}
                  </div>

                  <button
                    className={`start-audio-btn ${isBroadcasting ? "active" : ""}`}
                    onClick={startBroadcasting}
                    disabled={calling}
                  >
                    🎤 {isBroadcasting ? "Broadcasting…" : "Start Broadcasting"}
                  </button>

                  {isBroadcasting && (
                    <button
                      className="stop-audio-btn"
                      onClick={() => {
                        stopBroadcasting();
                        window.location.reload();
                      }}
                    >
                      🔴 Stop Broadcasting
                    </button>
                  )}

                  {Object.keys(availableAudioUsers).length > 0 ? (
                    <div className="audio-users-list">
                      <p
                        style={{
                          marginBottom: "10px",
                          fontSize: "12px",
                          color: "var(--text-secondary)",
                        }}
                      >
                        Available Broadcasters:
                      </p>
                      {Object.entries(availableAudioUsers).map(
                        ([socketId, info]) => {
                          if (socketId === socketRef.current?.id) return null;

                          return (
                            <div key={socketId} className="audio-user-row">
                              <span>
                                {info.username}
                                {speakingUsers[info.username] && (
                                  <span className="speaking-indicator">
                                    Speaking
                                  </span>
                                )}
                              </span>

                              <div style={{ display: "flex", gap: "5px" }}>
                                <button
                                  onClick={() => startListeningTo(socketId)}
                                  disabled={
                                    listeningTo && listeningTo !== socketId
                                  }
                                  className={`listen-btn ${listeningTo === socketId ? "active" : ""}`}
                                >
                                  {listeningTo === socketId
                                    ? "✓ Listening"
                                    : "Listen"}
                                </button>

                                {listeningTo === socketId && (
                                  <button
                                    className="stop-listen-btn"
                                    onClick={() => {
                                      cleanupPeerConnection(socketId);
                                      setListeningTo(null);
                                      toast("Stopped listening");
                                      window.location.reload();
                                    }}
                                  >
                                    Stop
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        },
                      )}
                    </div>
                  ) : (
                    <div className="audio-users-empty">
                      No one is broadcasting
                    </div>
                  )}
                </div>

                {/* Active Members List */}
                <div className="members-list">
                  {clients.map((client) => (
                    <div key={client.socketId} className="member-item">
                      <div className="member-avatar">
                        {client.username.charAt(0).toUpperCase()}
                      </div>
                      <div className="member-info">
                        <span className="member-name">
                          {client.username}
                          {hostName === client.username && (
                            <span className="host-dot"></span>
                          )}
                          {speakingUsers[client.username] && (
                            <span
                              style={{
                                marginLeft: "5px",
                                fontSize: "10px",
                                color: "#48bb78",
                              }}
                            >
                              ● Speaking
                            </span>
                          )}
                        </span>
                        {typers.includes(client.username) &&
                          client.username !== username && (
                            <span className="typing-indicator">typing...</span>
                          )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="sidebar-actions">
                <button className="btn-copy-room" onClick={copyRoomId}>
                  <FontAwesomeIcon icon={faCopy} /> Copy Room ID
                </button>
                <button className="btn-leave" onClick={leaveRoom}>
                  <FontAwesomeIcon icon={faSignOutAlt} /> Leave Room
                </button>
              </div>
            </>
          )}
        </div>
      )}

      {/* Main Content */}
      <div className={`main-content ${isEditorFullscreen ? 'fullscreen' : ''}`}>
        {/* Top Navigation Bar - hide when editor is in fullscreen mode */}
        {!isEditorFullscreen && (
          <nav className="editor-navbar">
            <div className="nav-left">
              <div className="language-selector">
                <label>
                  <FontAwesomeIcon icon={faCode} /> Language
                </label>
                <select
                  value={language}
                  onChange={(e) => {
                    const newLang = e.target.value;
                    setLanguage(newLang);
                    setSelectedLanguage(newLang);
                    applyLanguageTemplate(newLang);
                  }}
                  className="select-box"
                >
                  {/* Core Web & Scripting */}
                  <option value="html">HTML</option>
                  <option value="css">CSS</option>
                  <option value="htmlcss">HTML+CSS</option>
                  <option value="javascript">JavaScript</option>
                  <option value="python">Python</option>
                  <option value="node">Node.js</option>
                  <option value="php">PHP</option>
                  <option value="ruby">Ruby</option>
                  
                  {/* Compiled Languages */}
                  <option value="c">C</option>
                  <option value="cpp">C++</option>
                  <option value="java">Java</option>
                  <option value="csharp">C#</option>
                  <option value="go">Go</option>
                  <option value="rust">Rust</option>
                  
                  {/* JVM Languages */}
                  <option value="groovy">Groovy</option>
                  
                  {/* Other Languages */}
                  <option value="typescript">TypeScript</option>
                  <option value="swift">Swift</option>
                  <option value="dart">Dart</option>
                  <option value="julia">Julia</option>
                  
                  {/* Scripting & Specialized */}
                  <option value="r">R</option>
                  <option value="mysql">MySQL</option>
                </select>
              </div>

              <div className="theme-selector">
                <label>Theme</label>
                <div className="theme-buttons">
                  {THEMES.map((t) => (
                    <button
                      key={t.value}
                      className={`theme-btn ${theme === t.value ? "active" : ""}`}
                      onClick={() => setTheme(t.value)}
                      title={t.name}
                      style={{ backgroundColor: t.preview }}
                    />
                  ))}
                </div>
              </div>

              <div className="font-size-control">
                <label>Font Size</label>
                <div className="font-size-buttons">
                  <button onClick={() => setFontSize((f) => Math.max(12, f - 1))}>
                    -
                  </button>
                  <span>{fontSize}px</span>
                  <button onClick={() => setFontSize((f) => Math.min(24, f + 1))}>
                    +
                  </button>
                </div>
              </div>
            </div>

            <div className="nav-right">
              <button className="btn-ai" onClick={() => setAIOpen(!aiOpen)}>
                <FontAwesomeIcon icon={faRobot} /> AI Assistant
              </button>
              <button className="btn-chat" onClick={() => setChatOpen(!chatOpen)}>
                💬 Chat
              </button>
            </div>
          </nav>
        )}

        {/* Editor Area */}
        <div className={`editor-area ${isEditorFullscreen ? 'fullscreen' : ''}`}>
          <div className="editor-toolbar">
            <div className="toolbar-left">
              <button
                className="toolbar-btn"
                onClick={() => editorRef.current?.undo()}
                disabled={!canUndo}
                title="Undo (Ctrl+Z)"
              >
                <FontAwesomeIcon icon={faUndo} /> Undo
              </button>
              <button
                className="toolbar-btn"
                onClick={() => editorRef.current?.redo()}
                disabled={!canRedo}
                title="Redo (Ctrl+Shift+Z)"
              >
                <FontAwesomeIcon icon={faRedo} /> Redo
              </button>
              <div className="auto-run-toggle">
                <label>
                  <input
                    type="checkbox"
                    checked={autoRun}
                    onChange={(e) => setAutoRun(e.target.checked)}
                  />
                  Auto Run
                </label>
              </div>
              {/* Add fullscreen toggle button */}
              <button
                className="toolbar-btn fullscreen-btn"
                onClick={toggleEditorFullscreen}
                title={isEditorFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
              >
                <FontAwesomeIcon icon={isEditorFullscreen ? faCompressAlt : faArrowsAlt} />
                {!isEditorFullscreen && " Fullscreen"}
              </button>
            </div>
            <div className="toolbar-right">
              <button
                className="toolbar-btn"
                onClick={copyCode}
                title="Copy Code"
              >
                <FontAwesomeIcon icon={faCopy} /> Copy
              </button>
              <button
                className="toolbar-btn"
                onClick={saveCode}
                title="Save Code"
              >
                <FontAwesomeIcon icon={faSave} /> Save
              </button>
              <button
  className="btn-run"
  onClick={executeCode}
  title="Run Code"
>
  <FontAwesomeIcon icon={faPlay} /> Run Code
</button>
            </div>
          </div>

          <div className="ace-editor-container">
            <div id="editor" className="ace-editor"></div>
          </div>

          {/* Hide I/O section when in fullscreen mode */}
          {!isEditorFullscreen && (
            <div className="io-section">
              <div className="input-section">
                <h5>Input</h5>
                <textarea
                  className="input-textarea"
                  placeholder="Enter input here..."
                  value={userInput}
                  onChange={(e) => setUserInput(e.target.value)}
                  spellCheck="false"
                />
              </div>
              <div className="output-section">
                <div className="output-header">
                  <h5>Output</h5>
                  <button className="clear-btn" onClick={() => setOutput("")}>
                    Clear
                  </button>
                </div>
                <pre className="output-content">
                  {output || "Output will appear here..."}
                </pre>
                {/* Footer at bottom of scroll */}
                <div className="output-footer">
                  <span>V Editor © 2026</span>
                  <span>
                    <a href="/privacy">Privacy</a> |<a href="/terms">Terms</a> |
                    <a href="/AboutUs">About</a> |<a href="/contact">Contact</a>
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Add this after your chat/ai panels */}
    
      {/* AI Assistant Panel */}
      {aiOpen && (
        <div className={`ai-panel ${isFullscreen ? "fullscreen" : ""}`}>
          <div className="ai-panel-header">
            <h4>
              <FontAwesomeIcon icon={faRobot} /> AI Code Assistant
            </h4>
            <div className="ai-panel-actions">
              <button
                className="ai-btn"
                onClick={() => setIsFullscreen(!isFullscreen)}
              >
                <FontAwesomeIcon icon={isFullscreen ? faCompress : faExpand} />
              </button>
              <button className="ai-btn close" onClick={() => setAIOpen(false)}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>
          <div className="ai-panel-content">
            <iframe
              src="/Suggestion"
              title="AI Assistant"
              className="ai-iframe"
            />
          </div>
        </div>
      )}

      {/* Chat Panel */}
      {chatOpen && (
        <div className="chat-panel">
          <div className="chat-panel-header">
            <h4>💬 Chat Room</h4>
            <button className="close-chat" onClick={() => setChatOpen(false)}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="chat-panel-content">
            <Chat username={username} roomId={roomId} />
          </div>
        </div>
      )}
    </div>
  );
}

export default EditorPage;